import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/auth-store.service';
import { OrganizationContextService } from '../services/organization-context.service';

export const organizationContextGuard: CanActivateChildFn = async () => {
  const authStore = inject(AuthStoreService);
  const organizationContext = inject(OrganizationContextService);
  const router = inject(Router);

  const isSuperAdmin = (authStore.user()?.type || []).includes('SUPERADMIN');

  if (!isSuperAdmin) {
    return true;
  }

  if (organizationContext.selectedOrganizationId()) {
    // Refresh the cache in the background so the header's "Cambiar" option reflects
    // whether switching is actually possible, even when a selection already exists.
    void organizationContext.loadOrganizations();
    return true;
  }

  const organizations = await organizationContext.loadOrganizations();

  if (organizations.length === 1) {
    organizationContext.select(organizations[0]);
    return true;
  }

  return router.createUrlTree(['/admin/select-organization']);
};
